<template>
  <crud-layout :title="title" :subtitle="subtitle">

    <template v-slot:list>
      <origen-deuda-list
          ref="list"
          @update="update"
          @delete="remove"
          @show="show"

      />
    </template>

    <add-button v-if="$store.getters.hasPermission('ORIGENDEUDA_CREATE')" @click="create"></add-button>

    <origen-deuda-create v-if="creating"
                         :open="creating"
                         v-on:itemCreated="onItemCreated"
                         v-on:close="creating=false"
    />

    <origen-deuda-update v-if="updating"
                         :open="updating"
                         :item="itemToEdit"
                         v-on:itemUpdated="onItemUpdated"
                         v-on:close="updating=false"
    />

    <origen-deuda-show v-if="showing"
                       :open="showing"
                       :item="itemToShow"
                       v-on:close="showing=false"
    />

    <origen-deuda-delete v-if="deleting"
                         :open="deleting"
                         :item="itemToDelete"
                         v-on:itemDeleted="onItemDeleted"
                         v-on:close="deleting=false"
    />

    <snackbar v-model="flash"/>

  </crud-layout>
</template>

<script>

import OrigenDeudaCreate from "../OrigenDeudaCreate";
import OrigenDeudaUpdate from "../OrigenDeudaUpdate";
import OrigenDeudaDelete from "../OrigenDeudaDelete";
import OrigenDeudaShow from "../OrigenDeudaShow";
import OrigenDeudaList from "../OrigenDeudaList";

import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"

export default {
  name: "OrigenDeudaCrud",
  components: {
    CrudLayout, AddButton, Snackbar,
    OrigenDeudaCreate,
    OrigenDeudaUpdate,
    OrigenDeudaDelete,
    OrigenDeudaShow,
    OrigenDeudaList
  },
  data() {
    return {
      title: 'cobrox.origenDeuda.title',
      subtitle: 'cobrox.origenDeuda.subtitle',
      flash: null,
      creating: false,
      updating: false,
      deleting: false,
      showing: false,
      itemToEdit: null,
      itemToDelete: null,
      itemToShow: null,
    }
  },
  methods: {
    //On
    onItemCreated() {
      this.$refs.list.fetch()
      this.flash = "common.created"
    },
    onItemUpdated() {
      this.$refs.list.fetch()
      this.flash = "common.updated"
    },
    onItemDeleted() {
      this.$refs.list.fetch()
      this.flash = "common.deleted"
    },
    //Open
    create() {
      this.creating = true
    },
    update(item) {
      this.updating = true
      this.itemToEdit = item
    },
    show(item) {
      this.showing = true
      this.itemToShow = item
    },
    remove(item) {
      this.deleting = true
      this.itemToDelete = item
    }
  }

}
</script>


